import { render, staticRenderFns } from "./DisputeBulkTabs.vue?vue&type=template&id=11503404&scoped=true"
import script from "./DisputeBulkTabs.vue?vue&type=script&lang=js"
export * from "./DisputeBulkTabs.vue?vue&type=script&lang=js"
import style0 from "./DisputeBulkTabs.vue?vue&type=style&index=0&id=11503404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11503404",
  null
  
)

export default component.exports